/**
 * THE READER'S TEXT SIZE DRIVES THE KIT'S ONE TYPE TOKEN.
 *
 * Every Book size is `calc(Npx * var(--bs))`, so a browser's text-size
 * preference (which changes the root font size, not px) used to change
 * nothing: QE measured the h1, body, buttons and rows unchanged at a 200%
 * root size. Web v2's 200% frame is explicit that "one type token scales the
 * whole screen, digits and button included", so the token follows the root:
 * a reader at 32px gets --bs 2.
 *
 * Page zoom was already fine (it scales px). This is for the other control.
 * Clamped to [1, 2]: never smaller than the design (a smaller preference is
 * served by page zoom), never beyond the scale the layouts were reflowed at.
 */
export const DEFAULT_ROOT_PX = 16;
/** From here up, the action area flows with the page instead of staying pinned (v3.css). */
export const LARGE_TEXT_SCALE = 1.5;

export function userTextScale(rootFontPx: number): number {
  if (!Number.isFinite(rootFontPx) || rootFontPx <= 0) return 1;
  return Math.min(2, Math.max(1, rootFontPx / DEFAULT_ROOT_PX));
}

/** Read once at boot. A text-size change takes effect on the next load. */
export function applyUserTextScale(doc: Document = document): number {
  const px = parseFloat(getComputedStyle(doc.documentElement).fontSize);
  const scale = userTextScale(px);
  doc.documentElement.style.setProperty("--l-user-scale", String(scale));
  doc.documentElement.dataset.textScale = String(scale);
  // A boolean CSS can select on: at 1.5x and up the action area flows with
  // the page instead of staying pinned (v3.css).
  doc.documentElement.dataset.largeText = String(scale >= LARGE_TEXT_SCALE);
  return scale;
}
